export default __webpack_public_path__ + "static/media/aijaz.9eff59bd.mp4";